import { useMemo } from 'react';
import { qsParse } from 'helpers/queryString';
import { useLocation } from 'react-router';

export const DEFAULT_FILTER = {
  sortBy: 'createdAt',
  sortDirection: 'desc',
  visibility: 'any',
  source: null,
  status: null,
  expiration: null,
  featured: null,
  expirationWithin: null,
  locationIds: [],
  sourcingCampaignStatus: [],
};

export const useJobsFilters = ({ forCompany }) => {
  const location = useLocation();

  const defaultFilter = useMemo(() => {
    if (forCompany?.id) {
      return {
        ...DEFAULT_FILTER,
        companyId: forCompany.id.toString(),
      };
    }

    return DEFAULT_FILTER;
  }, [forCompany]);

  const jobsFilters = useMemo(() => {
    const filter = qsParse(location);
    delete filter.page;
    const { locations, ...otherFilters } = filter;
    const currentFilters = { ...defaultFilter, ...otherFilters };

    if (locations) {
      try {
        const parsedLocations = JSON.parse(atob(locations));
        currentFilters.locations = parsedLocations.filter((item) => item.value !== 'remote');
        currentFilters.remote = currentFilters.locations.length === parsedLocations.length ? '' : 'remote';
        currentFilters.locationIds = parsedLocations.map(({ value }) => value);
      } catch (error) {
        currentFilters.locations = [];
        currentFilters.remote = '';
        currentFilters.locationIds = [];
      }
    }

    const mapNumberOfApplicants = {
      any: 'any',
      1: '1',
      0: '0',
    };
    currentFilters.numberOfApplicants = mapNumberOfApplicants[currentFilters.numberOfApplicants];

    // Parse sourcingCampaignStatus as array (bracket notation in URL: sourcingCampaignStatus[]=value1&sourcingCampaignStatus[]=value2)
    if (currentFilters.sourcingCampaignStatus) {
      if (!Array.isArray(currentFilters.sourcingCampaignStatus)) {
        // Handle single value or string
        currentFilters.sourcingCampaignStatus = [currentFilters.sourcingCampaignStatus].filter(Boolean);
      }
    } else {
      currentFilters.sourcingCampaignStatus = [];
    }

    return currentFilters;
  }, [defaultFilter, location]);

  return { jobsFilters, defaultFilter };
};
